import React, { useMemo } from "react";
import { useParams, useRouteMatch } from "react-router-dom";
import { useAccountFinancials } from "../hooks/useAccountFinancials";
import { FinancialDetail } from "./FinancialDetail";
import { Typography, BoxProps } from "@material-ui/core";
import { formatDate } from "../../../utils/formatDate";
import { formatMoneyWithSign } from "../../../utils/formatMoney";

export const LastBill: React.FC<BoxProps> = ({ ...props }) => {
  const { accountNumber } = useParams();
  const { data, status } = useAccountFinancials(accountNumber!);

  //Dependencies to check for memoization
  const lastBill = data?.lastBill;
  const hasLastBill = !!lastBill;
  const grossAmount = lastBill?.grossAmount;
  const currency = lastBill?.currency;
  const issueDt = lastBill?.issueDt;
  const { url } = useRouteMatch();

  const [amount, isCredit] = useMemo(() => {
    if (hasLastBill && grossAmount !== undefined) {
      return [
        formatMoneyWithSign(currency, grossAmount, {
          transform: Math.abs,
        }),
        Number(grossAmount) < 0,
      ];
    }
    return [undefined, undefined, undefined];
  }, [hasLastBill, grossAmount, currency]);

  const subtitles = useMemo(() => {
    return issueDt ? ["Issued " + formatDate(issueDt)] : undefined;
  }, [issueDt]);

  if (lastBill === null) return null;

  return (
    <FinancialDetail
      loading={status === "loading"}
      title="Latest bill"
      subtitles={subtitles}
      link={{ text: "View Bills", path: `${url}/financials/bills` }}
      {...props}
    >
      <Typography variant="h5" color="textPrimary" component="span">
        {amount}
      </Typography>
      {isCredit && (
        <Typography variant="body1" color="textSecondary" component="span">
          {" CR"}
        </Typography>
      )}
    </FinancialDetail>
  );
};
